"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VanillaHandler = void 0;
const types_1 = require("../../types");
const bignumber_1 = require("@ethersproject/bignumber");
const base_1 = require("./base");
class VanillaHandler extends base_1.StrategyHandlerBase {
    /**
     * Returns a `VanillaHandler` instance for the provided chain configuration
     * @param config The chain config
     */
    static for(config) {
        return new VanillaHandler(config);
    }
    /**
     * The governance power strategy type
     */
    get type() {
        return types_1.GovPowerStrategyType.VANILLA;
    }
    /**
     * The governance power strategy address
     */
    get address() {
        return this._addresses.starknet.govPower.vanilla;
    }
    /**
     * @notice Get the governance power strategy params that will be shared amongst all users
     * No params are required for the vanilla strategy.
     */
    async getStrategyParams() {
        return [];
    }
    /**
     * @notice Get the governance power strategy params for a single user.
     * No params are required for the vanilla strategy.
     */
    async getUserParams() {
        return [];
    }
    /**
     * @notice Returns a governance power of `1` for all users.
     */
    async getPower() {
        return bignumber_1.BigNumber.from(1);
    }
}
exports.VanillaHandler = VanillaHandler;
